export default __webpack_public_path__ + "1e17cbd332927f6b78bfb6b6b318a731.svg";